import { PromotionCode } from './view';

export default PromotionCode;
